import React from 'react';

/**
 * Full-screen blocking overlay shown while attachments are being malware-scanned and
 * the request is submitted (both happen within the same backend request/response).
 */
export function ScanningOverlay({ message = 'Scanning attachments for viruses…' }: { message?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={message}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <style>{`
        @keyframes vipmp-scanning-spin { to { transform: rotate(360deg); } }
      `}</style>
      <div
        style={{
          background: '#fff',
          borderRadius: 8,
          padding: '32px 40px',
          maxWidth: 360,
          width: '90%',
          textAlign: 'center',
          boxShadow: '0 12px 48px rgba(0,0,0,0.25)'
        }}
      >
        <div
          aria-hidden
          style={{
            width: 44,
            height: 44,
            margin: '0 auto 18px',
            border: '4px solid #e8e8e8',
            borderTopColor: '#eb1000',
            borderRadius: '50%',
            animation: 'vipmp-scanning-spin 0.8s linear infinite'
          }}
        />
        <p style={{ margin: 0, color: '#333', fontSize: 14, fontWeight: 600 }}>{message}</p>
        <p style={{ margin: '8px 0 0', color: '#777', fontSize: 12.5 }}>
          This may take a moment. Please don't close this window.
        </p>
      </div>
    </div>
  );
}
